import { RangeValues } from './form.types';

export const MAX_PRICE_RANGE: RangeValues = { min: 2000, max: 251000, step: 1000 };
export const MAX_FLIGHT_DURATION_RANGE: RangeValues = { min: 2, max: 40, step: 1 };
export const MAX_STOPS_RANGE: RangeValues = { min: 0, max: 5, step: 1 };
